import router from './index.js'
import bus from "../app/event";
import iView from 'iview'

/*一开始打开页面时的进度条*/
router.beforeEach((to, from, next) => {
    iView.LoadingBar.config({
        color: '#00FF00',
        failedColor: '#FF0000',
        height: 5
    });
    iView.LoadingBar.start();
    if (sessionStorage.getItem("AOTHOR_ID") == '1' && sessionStorage.getItem("ISADMIN")=='0') {
        if(to.fullPath!='/theme'){
            // router.push('/theme');
            // next('/theme')
            next({path: '/theme'})
            return
        }
    }
    next();
});
/*路由的进度条*/
router.afterEach(() => {
    bus.$emit("to_Home_Head");
    iView.LoadingBar.finish();
});



// WEBPACK FOOTER //
// ./src/router/toroute.js